import React, {useContext, useState} from 'react';
import {Button, ConfigProvider, DatePicker, Form, Modal, Select, Switch, Table, Spin} from 'antd';
import locale from "antd/es/locale/es_ES";
import dayjs, {Dayjs} from 'dayjs';
import {BiDownload, BiSearch} from "react-icons/bi";
import Colors from "../../../styles/Colors";
import RegistreFiltre from '../../../model/root/RegistreFiltre';
import {ColumnsType} from "antd/es/table";
import {PostRegistreHorari} from '../../../dao/root/PostRegistreHorari';
import jsPDF from 'jspdf';
import {AuthContext} from "../../../config/AuthContext";
import {useParams} from "react-router-dom";
import RegistreHorari from '../../../model/root/RegistreHorari';
import autoTable from 'jspdf-autotable';
import {GetUsuariIdPerfil} from '../../../dao/root/GetUsuariIdPerfil';


const {RangePicker} = DatePicker;
const {Option} = Select;

interface RegistreModalProps {
    visible: boolean;
    onClose: (value: boolean) => void;
}

const EstadistiquesHorariesPdfModal: React.FC<RegistreModalProps> = ({visible, onClose}) => {
    const [form] = Form.useForm();
    const [rebutFiltre, setRebutFiltre] = useState<RegistreFiltre>(new RegistreFiltre());
    const [dateType, setDateType] = useState<'mes' | 'personalitzat'>('mes'); // estado para el dropdown
    const [descaregarModal, setDescarregarPdf] = useState(false);
    const [coleccio, setDades] = useState<RegistreHorari[]>([]);
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const {id_usuari, empresa} = useParams();
    const [filtreText, setFiltreText] = useState<string>("");
    const [nomUsuari, setNomUsuari] = useState<string>("");
    const [usuari, setUsuari] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);

    const handleSubmit = async () => {
        setLoading(true); // Comienza el spinner

        try {
            const dadesUsu = await GetUsuariIdPerfil(id_usuari!, page);
            setUsuari(dadesUsu && dadesUsu.length > 0 ? dadesUsu[0] : {});

            const formData = form.getFieldsValue();
            const filtre: RegistreFiltre = {
                data_inici: null,
                data_fi: null,
                mes: 0,
                any: 0,
            };

            if (dateType === 'mes' && formData.month) {
                const selectedDate = dayjs(formData.month);
                filtre.mes = parseInt(selectedDate.format('MM'));
                filtre.any = parseInt(selectedDate.format('YYYY'));
                setFiltreText(`Mes: ${selectedDate.format('MM/YYYY')}`);
            } else if (dateType === 'personalitzat' && formData.dates?.length === 2) {
                filtre.data_inici = formData.dates[0].format('YYYY-MM-DD');
                filtre.data_fi = formData.dates[1].format('YYYY-MM-DD');
                setFiltreText(`Del ${formData.dates[0].format('DD/MM/YYYY')} al ${formData.dates[1].format('DD/MM/YYYY')}`);
            }

            const dades = await PostRegistreHorari(empresa || page, filtre, id_usuari);
            setDades(dades || []);

            setDescarregarPdf(true);
        } catch (error) {
            console.error("Error carregant dades:", error);
        } finally {
            setLoading(false); // Finaliza el spinner
        }
    };


    const handleCancel = () => {
        onClose(false);
    };

    const handleDateTypeChange = (value: 'mes' | 'personalitzat') => {
        setDateType(value);
        // Resetear fechas en el estado y el form cuando cambie tipo
        setRebutFiltre(new RegistreFiltre());
        form.resetFields(['month', 'dates']);
    };


    const handleMonthChange = (date: Dayjs | null) => {
        const formattedMonth = date ? date.format("MM/YYYY") : "";
        setRebutFiltre((prev) => ({
            ...prev,
            dataInici: formattedMonth,
            dataFi: formattedMonth,
        }));
    };

    type RangeValue = [Dayjs | null, Dayjs | null] | null;
    const handleDateRangeInput = (dates: RangeValue) => {
        const startDate = dates?.[0]?.format("DD/MM/YYYY") || "";
        const endDate = dates?.[1]?.format("DD/MM/YYYY") || "";
        setRebutFiltre((prev) => ({
            ...prev,
            dataInici: startDate,
            dataFi: endDate,
        }));
    };

    function handleCloseModal(refresh: boolean) {
        setDescarregarPdf(false);
    }

    const columns: ColumnsType<RegistreHorari> = [
        {
            key: 'data',
            title: 'Data',
            dataIndex: 'data',
            defaultSortOrder: 'descend',
            width: 5,
            responsive: ['lg'],
        },

        {
            key: 'entrada',
            title: 'Entrada',
            dataIndex: 'entrada',
            width: 100,
            responsive: ['lg'],
        },
        {
            key: 'sortida',
            title: 'Sortida',
            dataIndex: 'sortida',
            width: 100,
            responsive: ['lg'],
        },
        {
            key: 'hores_treballades',
            title: 'Hores treballades',
            dataIndex: 'hores_treballades',
            width: 100,
            responsive: ['lg'],
        },

    ];
    const handleDownloadPdf = () => {
        const pdf = new jsPDF();
        const today = dayjs().format("DD/MM/YYYY");

        if (filtreText) {
            pdf.setFontSize(14);
            pdf.text(`Registre horari - ${filtreText}`, 10, 15);
        }
        pdf.setFontSize(11);
        pdf.setTextColor(100); // gris oscuro
        pdf.text(`Registre diari d’entrades i sortides amb el total d’hores treballades per l’usuari ${usuari.nom}`, 10, 20);

        const tableData = coleccio.map((item) => [
            item.data,
            item.entrada,
            item.sortida,
            item.hores_treballades
        ]);

        autoTable(pdf, {
            head: [['Data', 'Entrada', 'Sortida', 'Hores treballades']],
            body: tableData,
            startY: 25,
            margin: {top: 20, left: 10, right: 10},
            styles: {
                fontSize: 10,
                cellPadding: 3,
            },
            headStyles: {
                fillColor: [220, 220, 220],
                textColor: 0,
                halign: 'center',
            },
            bodyStyles: {
                halign: 'center',
            },
            didDrawPage: function (data: any) {
                const pageHeight = pdf.internal.pageSize.height;
                pdf.setFontSize(10);
                pdf.setTextColor(150);
                pdf.text(`Llistat obtingut a dia ${today}`, data.settings.margin.left, pageHeight - 10);
            }
        });

        pdf.save(`registre_horari_${dayjs().format("YYYYMMDD_HHmmss")}.pdf`);
    };

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="Descarrega el registre d’horaris en format PDF"
                open={visible}
                onCancel={handleCancel}
                footer={[]}
                width={"60%"}
            >
                <Form form={form} onFinish={handleSubmit}>
                    <hr/>

                    <Form.Item label="Tipus de data" name="dateType" initialValue="mes"
                               style={{display: 'inline-block', width: 'calc(24% - 8px)', margin: '0 8px'}}>
                        <Select onChange={handleDateTypeChange}>
                            <Option value="mes">Mes</Option>
                            <Option value="personalitzat">Personalitzat</Option>
                        </Select>
                    </Form.Item>

                    {dateType === 'mes' && (

                        <Form.Item
                            label="Mes i any"
                            name="month"
                            style={{display: 'inline-block', width: 'calc(40% - 8px)', margin: '0 8px'}}
                        >
                            <DatePicker
                                picker="month"
                                format="MM/YYYY"
                                style={{width: "100%"}}
                                onChange={handleMonthChange}
                                placeholder="Selecciona mes i any"
                            />
                        </Form.Item>

                    )}

                    {dateType === 'personalitzat' && (

                        <Form.Item
                            label="Interval de dates"
                            name="dates"
                            style={{display: 'inline-block', width: 'calc(40% - 8px)', margin: '0 8px'}}
                        >
                            <RangePicker
                                style={{width: "100%"}}
                                placeholder={["Data inici", "Data fi"]}
                                format="DD/MM/YYYY"
                                onChange={handleDateRangeInput}
                            />
                        </Form.Item>

                    )}

                    <Form.Item
                        label="Hores extres"
                        name="extras"
                        style={{display: 'inline-block', width: 'calc(20% - 8px)', margin: '0 8px'}}
                    >
                        <Switch/>
                    </Form.Item>
                    <Form.Item label={"  "}
                               name="button"
                               style={{display: 'inline-block', width: 'calc(10% - 8px)', margin: '0 8px'}}
                    >
                        <Button title="Buscar" style={{backgroundColor: Colors.colors.color6}}
                                htmlType="submit"><BiSearch/></Button>
                    </Form.Item>

                    <hr/>

                </Form>


              {(loading || descaregarModal) && (
                
                <Spin spinning={loading}>
                    <div style={{padding: '20px', backgroundColor: 'white'}}>
                            {filtreText && (
                                <>
                                    <h5 style={{marginTop: 20}}>Registre horari - {filtreText}</h5>
                                    <p>Registre diari d’entrades i sortides amb el total d’hores treballades per
                                        l’usuari <strong>{usuari.nom}</strong></p>
                                </>
                            )}
                            <p></p>
                            <Table
                                columns={columns}
                                dataSource={coleccio}
                                rowKey={(_, index) => index!}

                            />

                        </div>
                        <div style={{margin: "20px 0"}}>
                            <Button icon={<BiDownload/>} onClick={handleDownloadPdf}
                                    style={{backgroundColor: Colors.colors.color4}}>
                                Descarregar PDF
                            </Button>
                        </div>
                     </Spin>
                )}

            </Modal>

        </ConfigProvider>
    );
};

export default EstadistiquesHorariesPdfModal;
